export default __webpack_public_path__ + "locales/cs/Settings.json?hash=b7174371fb4a0919c2fde3d21f0ce1e0";